(ns teamoesterreich.admin-mode.selection.selection-table
  (:require ["react-virtualized" :as rv]
            [clojure.string]
            [reagent-material-ui.components :as mui]
            [goog.date.DateTime]
            [teamoesterreich.syncer :as sync]

            [teamoesterreich.view-state :as v-state]
            [teamoesterreich.admin-mode.data.webSelection :as d-webSelection]
            [teamoesterreich.admin-mode.data.organisation :as d-organisation]
            [reagent.core :as r]
            [teamoesterreich.util.log :as log]
            [reagent-material-ui.icons.delete-outline :as ic-delete]
            [reagent-material-ui.icons.info :as info]
            ))


(defn filter-fn [rows search]
  ;;(println "filter-fn " (count rows) search)
  (filter (fn [e]
            (re-find
              (re-pattern (reduce (fn [c e] (str c "(?=.*" e ")")) "(?i)^" (clojure.string/split  search " ")))
              (str (:user-tomId e) "#" (:user-firstName e) "#" (:user-lastName e) "#" (:user-email e) "#" (:user-phoneNumber e))))
          rows))

(defn select-me-renderer [!st]
  (fn [js-parm]
    (let [{cell-data "cellData"} (js->clj js-parm)
          !selected (r/cursor v-state/app-state [:selected-elements])
          !selection-uuid (r/cursor v-state/app-state [:selected-elements :list-uuid])
          !selection-loaded (r/cursor v-state/app-state [:selected-elements :loaded])
          !selectionLists-loaded (r/cursor v-state/app-state [:selected-elements :lists-loaded])]
      (r/as-element
        [mui/icon-button
         {:onClick  (fn [] (d-webSelection/>remove-user @!selection-uuid [cell-data]
                                                        (fn [] (reset! !selectionLists-loaded false) (reset! !selection-loaded false)))) }
         [ic-delete/delete-outline]
         ]))))




(defn org-renderer [dst-list]
  (fn [js-parm]
    (let [{rowData "rowData"} (js->clj js-parm)
          cell-data (get rowData "orgId")]
      ;(js/console.log "rowData" (clj->js (get rowData "orgId")))
      (r/as-element
        [:span (or (get dst-list cell-data) (str "" cell-data))]))))





(defn info-cell-renderer [js-parm]
  (let [{cell-data "cellData"} (js->clj js-parm)]
    (r/as-element
      [mui/icon-button {:label "bearbeiten"
                        :onClick (fn []
                                   (log/debug "bearbeiten geklickt " cell-data)
                                   (swap! v-state/app-state assoc-in [:toe-map :activeUserPopup] cell-data))
                        } [info/info {:fontSize "small"}]])))

(defn email-cell-renderer [js-parm]
  (let [{cell-data "cellData"} (js->clj js-parm)]
    ;(println "email-cell-renderer " cell-data)
    (r/as-element
      [:a {:href (str "mailto:" cell-data) :title cell-data} cell-data])))

(defn birthday-renderer [js-parm]
  (let [{cell-data "cellData"} (js->clj js-parm)
        ;l-date (date-h/parse-local-date cell-data)
        ]
    ;(js/console.log l-date)
    (r/as-element
      [:span (if (> (count cell-data) 10)
               (str (subs cell-data 6 8) "." (subs cell-data 4 6) "." (subs cell-data 0 4))
               "-")])))




(defn inside-table [!st rows]

  (fn [m]
    (let [width (aget m "width")
          height (aget m "height")
          !sort (r/cursor !st [:sort])
          !reverse (r/cursor !st [:reverse])

          _ (d-organisation/get-store-organisations)
          !organisations (r/cursor v-state/app-state [:organisations])
          dst-list (reduce (fn [c [k v]] (assoc c k v)) {} (d-organisation/get-dest-list @!organisations))
          ]
      (r/as-element
        [:> rv/Table
         {:headerHeight 50
          :height (- height 50)
          :rowCount (count rows)
          :rowGetter (fn [i]
                       ;(println (str "rowGet " (aget i "index")))
                       (clj->js (nth rows (aget i "index"))))
          :rowClassName (fn [i] (when (odd? (aget i "index")) "table-odd"))
          :sort (fn [s] (swap! !st assoc :sort (aget s "sortBy") :reverse (= "DESC" (aget s "sortDirection"))))
          :sortBy @!sort
          :sortDirection (if @!reverse "DESC" "ASC")
          :rowHeight 45
          :width width
          :headerClassName "headerColumn"
          :className "SelectionLsit"}

         [:> rv/Column
          {:label (r/as-element [ic-delete/delete-outline ])
           :dataKey (name :user-tomId)
           :className "bordered exampleColumn"
           :cellRenderer (select-me-renderer !st)
           :width 70} [:a {:href ""}]]

         [:> rv/Column
          {:label (r/as-element [info/info {:disabled true}])
           :dataKey (name :user-tomId)
           :className "bordered exampleColumn"
           :style #js { :overflow "hidden" }
           :cellRenderer info-cell-renderer
           :width 70}]

         [:> rv/Column
          {:label "TomId"
           :dataKey (name :user-tomId)
           :className "bordered exampleColumn"
           :style #js { :overflow "hidden" }
           :width 70}]

         [:> rv/Column
          {:label "Vorname"
           :dataKey (name :user-firstName)
           :className "bordered exampleColumn"
           :style #js { :overflow "hidden" }
           :width 170}]
         [:> rv/Column
          {:label "Nachname"
           :dataKey (name :user-lastName)
           :className "bordered exampleColumn"
           :width 170}]
         [:> rv/Column
          {:label "Plz"
           :dataKey (name :user-zip)
           :className "bordered exampleColumn"
           :width 170}]
         [:> rv/Column
          {:label "geboren"
           :dataKey (name :user-birthday)
           :cellRenderer birthday-renderer
           :className "bordered exampleColumn"
           :width 170}]


         [:> rv/Column
          {:label "Dienststelle"
           :cellRenderer (org-renderer dst-list)
           :className "bordered exampleColumn"
           :width 170}]



         ]))))





(defn table [!st rows]
  (fn [] [:> rv/AutoSizer
          {:style { :height "100%" :minHeight "400px"}
           :sort (str "rerender !st" @!st)}

          (inside-table !st rows)]))